import { render, staticRenderFns } from "./movement-table.vue?vue&type=template&id=35b5b73b&"
import script from "./movement-table.vue?vue&type=script&lang=js&"
export * from "./movement-table.vue?vue&type=script&lang=js&"
import style0 from "./movement-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports